export const getCookie = (cname: string) => {
	const name = cname + "=";
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(";");
	for (const caItem of ca) {
		let c = caItem;

		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const setCookie = (cname: string, cvalue: string, exseconds: number) => {
	const d = new Date();
	if (exseconds === 0) {
		const timezoneOffset = d.getTimezoneOffset();
		if (timezoneOffset > 0) {
			d.setMinutes(24 * 60 - (timezoneOffset + 1));
		} else {
			d.setMinutes(-timezoneOffset);
		}
		d.setUTCHours(16, 0, 0); /* set UTC time 16:00 hour as expirey of cookie as per current requirement. */
	} else {
		d.setTime(d.getTime() + exseconds * 1000);
	}
	const expires = `expires=${d.toUTCString()}`;

	document.cookie = `${cname}=${cvalue};${expires};path=/;secure;`;
};

export const getAccessToken = () => {
	const name = "USER_INFO_COOKIE=";
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(";");
	for (const caItem of ca) {
		let c = caItem;

		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return JSON.parse(c.substring(name.length, c.length)).jwtToken;
		}
	}
	return "";
};

export const invalidateCookie = () => {
	document.cookie = "USER_INFO_COOKIE= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
};
